<template>
	<div>
	  <div class="red_top_bg">
		<div
		  class="back_left"
		  @click="$router.back()"
		/>
		<div class="big_tit">
		  {{ $t('pagea.jfsc') }}
		</div>
	  </div>
	  <div v-if="info.img">
		  <img :src="info.img" class="good_img"/>
		  <div class="good_name">
			  {{ info[lang] }}
		  </div>
		  <div class="good_score">
			  {{ $t('pagea.jg') }}:{{ info.num }}{{ $t('pagea.jf') }}
		  </div>
		  <div class="label_wrap" style="">{{ $t('pagea.spjs') }}</div>
		  <div class="good_detail" v-html="info['content_'+lang]">
			  
		  </div>
	  </div>
	  <div class="bot_wrap">
		  <div class="bot_left" @click="tohome">
			  <div><van-icon name="wap-home-o" size="20"/></div>
			  <div style="margin-top: 3px;">{{ $t('home.index') }}</div>
		  </div>
		  <div class="bot_right" @click="toduihuan">
			  {{ $t('pagea.ljdh') }}
		  </div>
	  </div>
	</div>
</template>

<script>
    import Fetch from '../../utils/fetch'
	import Vue from 'vue';
	import { Icon } from 'vant';
	
	Vue.use(Icon);
	export default{
		data(){
			return{
				id:'',
				info:{},
				lang:this.$i18n.locale||"zh_cn",
			}
		},
        created() {
            this.$parent.footer('user', false);
        },
		mounted() {
			this.getdata();
		},
		methods:{
			tohome(){
				this.$router.push("/");
			},
			toduihuan(){
				let id=this.$router.history.current.params.id;
				this.$router.push("/jforder/"+id);
			},
			getdata(){
				let self=this;
				Fetch('/index/goodsdetail', {id: this.$router.history.current.params.id}).then((res) => {
					let result=res.data;
					this.info=result;
					console.log(result);
				});
			},
		}
	}
	
</script>

<style lang="less" scoped>
	.bot_wrap{
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #fff;
	}
	.bot_left{
		text-align: center;
		color: #000;
		padding: 0 20px;
	}
	.bot_right{
		flex: 1;
		width: 1px;
		background-color: #e54d42;
		color: #fff;
		text-align: center;
		font-size: 16px;
		padding: 20px 0;
	}
	.good_img{
		width: 100%;
	}
	.label_wrap{
		padding: 10px;border-bottom: 1px solid #ddd;font-size: 14px;color: #fff;
	}
	.good_name{
		padding: 20px 0;
		text-align: center;
		font-size: 16px;
		font-weight: 700;
		color: #fff;
	}
	.good_score{
		padding-bottom: 20px;
		text-align: center;
		font-size: 16px;
		color: #fff;
	}
	.good_detail{
		color: #fff;
		padding: 10px;
	}
</style>